import React, { FC } from 'react';
import { Tooltip } from 'react-tooltip';

import classes from './PickerLabel.scss';

type Props = {
    isDropdownView?: boolean;
    setIsDropdownView: (value: boolean) => void;
    title: string;
};

export const PickerLabel: FC<Props> = ({ isDropdownView, setIsDropdownView, title }) => (
    <label className={classes.pickerLabel}>
        <img
            className={classes.pickerIcon}
            src={require(`../../../static/icons/${isDropdownView ? 'gridToggleWhite' : 'gridToggleBlack'}.svg`)}
            alt="toggle grid"
            data-img="img-only"
            onClick={() => setIsDropdownView(!isDropdownView)}
            data-tooltip-id="picker-label-toggle"
            data-tooltip-content={isDropdownView ? `Switch to ${title} grid view` : `Switch to single ${title} view`}
        />
        <Tooltip {...({ id: 'picker-label-toggle', variant: 'light', closeOnClick: true } as any)} />
    </label>
);
